import { StatModule } from "@/core/modules/stat/objects/StatModule";

import BranchWithEmployeeView from "./views/BranchWithEmployeeView.vue";

export const branchWithEmployee: StatModule = new StatModule("employeeRoster", "BranchWithEmployee", "employeeRoster", BranchWithEmployeeView);
